export default "/_next/static/images/powered_by_google_on_non_white-fbdfc63b5ccf5d9f1e184ecfe09264e3.png";